import React from "react";

import {
  Box,
  Typography,
  Container,
  Grid,
  Paper,
  Stack
} from "@mui/material";

import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import VerifiedIcon from "@mui/icons-material/Verified";

const AboutPage = () => {
  return (
    <Box
      sx={{
        background: "#fff8f2",
        minHeight: "100vh"
      }}
    >
      {/* HERO */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg,#5c0000,#8B0000)",
          color: "#fff",
          py: {
            xs: 8,
            md: 12
          }
        }}
      >
        <Container maxWidth="lg">
          <Typography
            sx={{
              fontSize: {
                xs: "2.5rem",
                md: "4.5rem"
              },
              fontWeight: 900,
              mb: 3,
              lineHeight: 1
            }}
          >
            About
            <br />
            SwadVeda
          </Typography>

          <Typography
            sx={{
              fontSize: {
                xs: 16,
                md: 20
              },
              lineHeight: 1.9,
              maxWidth: 750,
              opacity: 0.92
            }}
          >
            SwadVeda Masale brings authentic
            Indian flavors crafted with
            premium ingredients, purity and
            traditional recipes that transform
            everyday cooking into a rich and
            unforgettable culinary experience.
          </Typography>
        </Container>
      </Box>

      {/* STORY */}
      <Container
        maxWidth="lg"
        sx={{
          py: {
            xs: 8,
            md: 12
          }
        }}
      >
        <Grid
          container
          spacing={6}
          alignItems="center"
        >
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="https://images.unsplash.com/photo-1509358271058-acd22cc93898"
              alt="spices"
              sx={{
                width: "100%",
                borderRadius: "32px",
                height: {
                  xs: 350,
                  md: 500
                },
                objectFit: "cover",
                boxShadow:
                  "0 20px 50px rgba(0,0,0,0.12)"
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography
              sx={{
                color: "#8B0000",
                fontWeight: 800,
                mb: 2,
                letterSpacing: 1
              }}
            >
              OUR STORY
            </Typography>

            <Typography
              sx={{
                fontSize: {
                  xs: "2rem",
                  md: "3rem"
                },
                fontWeight: 900,
                color: "#3d1f00",
                lineHeight: 1.1,
                mb: 3
              }}
            >
              Crafted With
              <br />
              Tradition & Trust
            </Typography>

            <Typography
              sx={{
                color: "rgba(0,0,0,0.7)",
                lineHeight: 2,
                mb: 3,
                fontSize: 16
              }}
            >
              At SwadVeda, we believe spices
              are the soul of Indian cooking.
              Every blend is carefully prepared
              using authentic recipes and
              high-quality ingredients sourced
              from trusted farms.
            </Typography>

            <Typography
              sx={{
                color: "rgba(0,0,0,0.7)",
                lineHeight: 2,
                fontSize: 16
              }}
            >
              From traditional kitchens to
              modern homes, our mission is to
              deliver freshness, aroma and
              purity in every pack.
            </Typography>
          </Grid>
        </Grid>
      </Container>

      {/* FEATURES */}
      <Box
        sx={{
          py: {
            xs: 8,
            md: 12
          },
          background:
            "linear-gradient(135deg,#fff1eb,#fff8f2)"
        }}
      >
        <Container maxWidth="lg">
          <Typography
            textAlign="center"
            sx={{
              fontSize: {
                xs: "2rem",
                md: "3rem"
              },
              fontWeight: 900,
              color: "#5c0000",
              mb: 2
            }}
          >
            Why Choose Us
          </Typography>

          <Typography
            textAlign="center"
            sx={{
              color: "text.secondary",
              maxWidth: 700,
              mx: "auto",
              lineHeight: 1.9,
              mb: 8
            }}
          >
            Premium quality spices with
            authentic taste and trusted purity.
          </Typography>

          <Grid container spacing={4}>
            {[
              {
                icon: <WorkspacePremiumIcon />,
                title: "100% Pure",
                desc:
                  "No artificial colors or preservatives."
              },
              {
                icon: <RestaurantIcon />,
                title: "Authentic Taste",
                desc:
                  "Traditional Indian spice blends."
              },
              {
                icon: <LocalShippingIcon />,
                title: "Freshly Packed",
                desc:
                  "Packed hygienically for freshness."
              },
              {
                icon: <VerifiedIcon />,
                title: "Trusted Quality",
                desc:
                  "Premium ingredients from trusted farms."
              }
            ].map((item) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                key={item.title}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    borderRadius: "30px",
                    height: "100%",
                    background: "#fff",
                    border:
                      "1px solid rgba(139,0,0,0.08)",
                    transition: "0.3s",

                    "&:hover": {
                      transform:
                        "translateY(-8px)",
                      boxShadow:
                        "0 15px 40px rgba(0,0,0,0.08)"
                    }
                  }}
                >
                  <Box
                    sx={{
                      width: 70,
                      height: 70,
                      borderRadius: "20px",
                      background:
                        "linear-gradient(135deg,#8B0000,#5c0000)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      mb: 3
                    }}
                  >
                    {item.icon}
                  </Box>

                  <Typography
                    fontWeight={800}
                    mb={1.5}
                    color="#3d1f00"
                    fontSize="1.2rem"
                  >
                    {item.title}
                  </Typography>

                  <Typography
                    color="text.secondary"
                    lineHeight={1.8}
                  >
                    {item.desc}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default AboutPage;